export interface Article {
  id: string;
  title: string;
  description: string;
  thumbnail: string;
  category: string;
  categoryName: string;
  views: number;
  likes: number;
  duration: string;
  author: string;
  authorAvatar: string;
  date: string;
  tags: string[];
  content: string;
  featured: boolean;
}

export const articles: Article[] = [
  {
    id: "summer-travel-vlog-2026",
    title: "2026夏日旅行Vlog | 三亚海棠湾全攻略，带你玩转最美海岸线",
    description: "这个夏天，跟着镜头一起探索三亚海棠湾的绝美风景。从潜水到冲浪，从海鲜大餐到海边日落，最全旅行攻略一次看完！",
    thumbnail: "https://readdy.ai/api/search-image?query=Tropical%20beach%20paradise%20with%20crystal%20clear%20turquoise%20water%2C%20white%20sand%20beach%2C%20palm%20trees%2C%20summer%20vacation%20vibe%2C%20bright%20sunlight%2C%20wide%20angle%20landscape%20photography%2C%20vibrant%20colors%2C%20clean%20minimalist%20composition&width=800&height=450&seq=article-thumb-01&orientation=landscape",
    category: "lifestyle",
    categoryName: "生活",
    views: 238000,
    likes: 45600,
    duration: "12:38",
    author: "旅行达人小王",
    authorAvatar: "https://readdy.ai/api/search-image?query=Young%20Chinese%20man%20portrait%2C%20friendly%20smile%2C%20casual%20style%2C%20clean%20studio%20lighting%2C%20warm%20tone%2C%20professional%20headshot&width=80&height=80&seq=avatar-01&orientation=squarish",
    date: "2026-08-05",
    tags: ["旅行", "三亚", "Vlog", "海棠湾", "夏日"],
    featured: true,
    content: `<h2>三亚海棠湾——夏日旅行首选目的地</h2>
<p>三亚海棠湾位于海南岛南端，以其绵延的白色沙滩和清澈的海水闻名。这里不仅是度假胜地，更是水上运动爱好者的天堂。</p>
<h3>行程安排建议</h3>
<p>建议至少安排3-4天的行程。第一天可以适应环境，逛逛免税店；第二天体验水上项目；第三天前往周边景点；最后一天享受海滩放松时光。</p>
<h3>必打卡景点</h3>
<ul>
<li><strong>蜈支洲岛</strong>：潜水爱好者的天堂，水质清澈见底</li>
<li><strong>亚特兰蒂斯水世界</strong>：适合全家游玩的水上乐园</li>
<li><strong>海棠湾免税购物中心</strong>：购物爱好者的必去之地</li>
<li><strong>后海村</strong>：体验最地道的海南渔村生活</li>
</ul>
<h3>美食推荐</h3>
<p>来到三亚怎能不品尝海鲜？推荐去第一市场自选海鲜加工，新鲜实惠。椰子鸡、清补凉、抱罗粉也都是不容错过的海南特色美食。</p>
<p>整个旅程花费约5000元/人（含机票），性价比相当不错。最重要的是，记得做好防晒！</p>`,
  },
  {
    id: "ai-tools-guide-2026",
    title: "2026最全AI工具盘点 | 这10款神器让你工作效率翻倍",
    description: "盘点2026年最值得使用的AI效率工具，涵盖写作、设计、编程、视频制作等领域，手把手教你用AI提升工作效率。",
    thumbnail: "https://readdy.ai/api/search-image?query=Futuristic%20AI%20technology%20workspace%20with%20holographic%20displays%2C%20modern%20minimalist%20desk%20setup%2C%20artificial%20intelligence%20concept%2C%20clean%20white%20background%2C%20soft%20ambient%20lighting%2C%20professional%20tech%20photography&width=800&height=450&seq=article-thumb-02&orientation=landscape",
    category: "tech",
    categoryName: "科技",
    views: 356000,
    likes: 78200,
    duration: "18:25",
    author: "科技极客阿杰",
    authorAvatar: "https://readdy.ai/api/search-image?query=Young%20Chinese%20tech%20enthusiast%20portrait%2C%20modern%20glasses%2C%20friendly%20expression%2C%20casual%20hoodie%2C%20studio%20lighting%2C%20clean%20professional%20look&width=80&height=80&seq=avatar-02&orientation=squarish",
    date: "2026-08-03",
    tags: ["AI", "效率工具", "科技", "人工智能", "工作技巧"],
    featured: true,
    content: `<h2>AI工具正在改变我们的工作方式</h2>
<p>2026年，AI工具已经深入到我们工作的方方面面。从内容创作到数据分析，从代码编写到视频制作，AI正在以前所未有的速度提升我们的工作效率。</p>
<h3>写作类AI工具</h3>
<p>写作是AI应用最广泛的领域之一。无论是文案撰写、邮件回复还是长篇报告，AI都能提供有力辅助。推荐使用具备深度理解能力的工具，能够根据你的语气和风格进行个性化输出。</p>
<h3>设计类AI工具</h3>
<p>即使没有设计基础，现在也能通过AI工具制作出专业级别的视觉内容。图片生成、海报设计、Logo制作，AI让设计变得触手可及。</p>
<h3>编程类AI工具</h3>
<p>对于开发者来说，AI编程助手已经成为标配。代码补全、Bug修复、架构建议，AI正在重新定义软件开发的方式。</p>
<h3>视频制作类AI工具</h3>
<p>视频剪辑、字幕生成、特效添加——AI让视频制作的门槛大幅降低，个人创作者也能产出专业水准的视频内容。</p>
<p>选择合适的工具组合，你的工作效率至少能提升3倍以上！</p>`,
  },
  {
    id: "home-cooking-secrets",
    title: "家常菜终极秘籍 | 大厨教你做地道红烧肉，肥而不腻入口即化",
    description: "五星级酒店大厨亲授红烧肉制作秘诀，从选材到火候，每一个细节都不放过。学会这道菜，你就是家里的厨神！",
    thumbnail: "https://readdy.ai/api/search-image?query=Delicious%20Chinese%20braised%20pork%20belly%20dish%2C%20glossy%20red%20color%2C%20steaming%20hot%2C%20garnished%20with%20green%20onions%2C%20elegant%20ceramic%20plate%2C%20warm%20kitchen%20lighting%2C%20food%20photography%20style&width=800&height=450&seq=article-thumb-03&orientation=landscape",
    category: "food",
    categoryName: "美食",
    views: 189000,
    likes: 52300,
    duration: "15:42",
    author: "厨神老张",
    authorAvatar: "https://readdy.ai/api/search-image?query=Middle%20aged%20Chinese%20chef%20portrait%2C%20white%20chef%20uniform%2C%20warm%20smile%2C%20professional%20kitchen%20background%2C%20clean%20studio%20lighting&width=80&height=80&seq=avatar-03&orientation=squarish",
    date: "2026-08-04",
    tags: ["美食", "红烧肉", "家常菜", "烹饪教程", "中餐"],
    featured: true,
    content: `<h2>红烧肉——中国人最爱的家常菜</h2>
<p>红烧肉是一道经典的中式菜肴，肥而不腻、入口即化的口感深受人们喜爱。今天就让五星级大厨老张来教你如何做出完美的红烧肉。</p>
<h3>选材是关键</h3>
<p>做红烧肉首选五花肉，三层肥两层瘦的比例最为理想。肉质要新鲜，皮要完整，这样炖出来的肉才会软糯入味。</p>
<h3>焯水去腥</h3>
<p>五花肉切块后冷水下锅，加入姜片和料酒，大火煮开后撇去浮沫，捞出沥干水分。这一步可以有效去除肉的腥味。</p>
<h3>炒糖色</h3>
<p>锅中放少许油，加入冰糖，小火慢炒至琥珀色。这是红烧肉色泽红亮的关键步骤，火候一定要掌握好，炒过了会发苦。</p>
<h3>慢炖入味</h3>
<p>加入生抽、老抽、料酒、八角、桂皮等调料，注入开水没过肉块，大火煮开后转小火慢炖1.5小时。最后大火收汁即可。</p>
<p>按照这个步骤来做，保证你的红烧肉色泽红亮、肥而不腻、入口即化！</p>`,
  },
  {
    id: "esports-2026-worlds",
    title: "2026全球电竞总决赛精彩回顾 | 中国战队逆转夺冠，现场燃爆了！",
    description: "2026年全球电竞总决赛在上海圆满落幕，中国战队在决赛中上演惊天逆转，以3:2击败强敌夺得冠军！",
    thumbnail: "https://readdy.ai/api/search-image?query=Massive%20esports%20arena%20with%20spectacular%20stage%20lighting%2C%20packed%20audience%2C%20giant%20LED%20screens%2C%20competitive%20gaming%20event%2C%20exciting%20atmosphere%2C%20dramatic%20lighting%2C%20professional%20esports%20photography&width=800&height=450&seq=article-thumb-04&orientation=landscape",
    category: "gaming",
    categoryName: "游戏",
    views: 520000,
    likes: 125000,
    duration: "22:15",
    author: "电竞观察员小李",
    authorAvatar: "https://readdy.ai/api/search-image?query=Young%20Chinese%20gamer%20portrait%2C%20energetic%20expression%2C%20stylish%20streetwear%2C%20colorful%20background%2C%20modern%20studio%20lighting&width=80&height=80&seq=avatar-04&orientation=squarish",
    date: "2026-08-02",
    tags: ["电竞", "总决赛", "游戏", "赛事", "冠军"],
    featured: true,
    content: `<h2>2026全球电竞总决赛震撼落幕</h2>
<p>2026年8月1日，全球电竞总决赛在上海梅赛德斯-奔驰文化中心圆满落幕。来自中国的"星辰战队"在决赛中以3:2的比分逆转战胜韩国强队，夺得冠军奖杯。</p>
<h3>惊心动魄的决赛</h3>
<p>决赛采取BO5赛制。中国战队开局不利，连丢两局。就在所有人都以为大势已去时，战队调整战术，连扳三局完成惊天大逆转。现场一万五千名观众沸腾了！</p>
<h3>MVP选手的精彩表现</h3>
<p>战队核心选手"星河"在决胜局中发挥神勇，以完美的操作和战术意识带领团队走向胜利，荣膺总决赛MVP。</p>
<h3>电竞产业的蓬勃发展</h3>
<p>本届赛事总奖金池高达5000万美元，创历史新高。全球观看人数突破1.2亿，电竞正在成为最具影响力的新兴体育项目之一。</p>
<p>中国电竞的黄金时代，才刚刚开始！</p>`,
  },
  {
    id: "fitness-beginner-guide",
    title: "零基础健身入门指南 | 每天15分钟，30天练出好身材",
    description: "健身教练教你零基础也能轻松掌握的居家训练方案，不需要器械，每天只需15分钟，坚持30天效果惊人！",
    thumbnail: "https://readdy.ai/api/search-image?query=Bright%20modern%20home%20gym%20with%20yoga%20mat%2C%20dumbbells%2C%20natural%20sunlight%20streaming%20through%20large%20windows%2C%20clean%20minimalist%20space%2C%20fresh%20atmosphere%2C%20wellness%20lifestyle%20photography&width=800&height=450&seq=article-thumb-05&orientation=landscape",
    category: "sports",
    categoryName: "运动",
    views: 167000,
    likes: 38900,
    duration: "10:28",
    author: "健身教练大鹏",
    authorAvatar: "https://readdy.ai/api/search-image?query=Fitness%20trainer%20Chinese%20man%20portrait%2C%20athletic%20build%2C%20confident%20smile%2C%20sportswear%2C%20gym%20background%2C%20professional%20lighting&width=80&height=80&seq=avatar-05&orientation=squarish",
    date: "2026-08-01",
    tags: ["健身", "居家训练", "入门指南", "好身材", "健康"],
    featured: false,
    content: `<h2>零基础也能练出好身材</h2>
<p>很多人觉得健身需要办卡、买器械、请教练，门槛太高。其实不然！只要你愿意每天投入15分钟，在家就能练出理想身材。</p>
<h3>第一周：适应期</h3>
<p>从最基础的动作开始：深蹲、俯卧撑（可做跪姿）、平板支撑、臀桥。每个动作做3组，每组12-15次。重点是掌握正确的动作要领。</p>
<h3>第二周：加强期</h3>
<p>增加动作难度和组数。尝试标准俯卧撑、箭步蹲、仰卧起坐。每个动作4组，感受到肌肉的酸痛就对了！</p>
<h3>第三周：突破期</h3>
<p>加入HIIT训练元素，提高燃脂效率。波比跳、登山跑、开合跳等动作让你的心率飙升。</p>
<h3>第四周：巩固期</h3>
<p>综合前三周的训练内容，形成完整的训练体系。此时的你应该已经能看到明显的变化了！</p>
<p>坚持下去，30天后你会感谢现在努力的自己！</p>`,
  },
  {
    id: "music-production-start",
    title: "从零开始学音乐制作 | 小白也能做出专业级作品",
    description: "音乐制作人带你入门，从软件选择到编曲技巧，从混音到母带，手把手教你制作人生第一首歌。",
    thumbnail: "https://readdy.ai/api/search-image?query=Modern%20music%20production%20studio%20with%20MIDI%20keyboard%2C%20studio%20monitors%2C%20computer%20screen%20showing%20DAW%20software%2C%20warm%20ambient%20lighting%2C%20creative%20workspace%2C%20professional%20audio%20equipment&width=800&height=450&seq=article-thumb-06&orientation=landscape",
    category: "music",
    categoryName: "音乐",
    views: 145000,
    likes: 31200,
    duration: "20:15",
    author: "音乐人阿凯",
    authorAvatar: "https://readdy.ai/api/search-image?query=Chinese%20music%20producer%20portrait%2C%20creative%20look%2C%20headphones%20around%20neck%2C%20stylish%20casual%20wear%2C%20studio%20background%2C%20warm%20lighting&width=80&height=80&seq=avatar-06&orientation=squarish",
    date: "2026-07-30",
    tags: ["音乐制作", "编曲", "入门教程", "录音", "混音"],
    featured: false,
    content: `<h2>音乐制作没有想象中那么难</h2>
<p>在数字音乐时代，制作一首完整的歌曲不再需要昂贵的录音棚和设备。一台电脑、一副耳机，你就可以开始音乐制作之旅。</p>
<h3>选择你的DAW</h3>
<p>DAW（数字音频工作站）是音乐制作的核心软件。对新手来说，推荐从操作友好的软件入手。熟悉基本操作后再逐步深入。</p>
<h3>节奏是骨架</h3>
<p>先从鼓组编排开始。一个简单的kick-snare-hihat组合就能搭建起基本的节奏框架。慢慢加入更多打击乐元素。</p>
<h3>和弦是血肉</h3>
<p>学习基本的和弦进行，比如经典的I-V-vi-IV。用钢琴或合成器音色弹奏，感受和声带来的情感变化。</p>
<h3>旋律是灵魂</h3>
<p>在节奏与和弦的基础上创作旋律。不要想得太复杂，有时候最简单的旋律最能打动人心。</p>
<h3>混音与母带</h3>
<p>调整各音轨的音量平衡，添加EQ、压缩、混响等效果。最后通过母带处理让作品听起来更专业。</p>
<p>记住，音乐制作最重要的是享受创作的过程！</p>`,
  },
  {
    id: "fashion-week-2026-trends",
    title: "2026秋冬时装周趋势解读 | 这5个穿搭公式必须收藏",
    description: "2026秋冬四大时装周刚刚落幕，我们为你总结了最值得关注的5大流行趋势，让你走在时尚最前沿。",
    thumbnail: "https://readdy.ai/api/search-image?query=Fashion%20runway%20show%20with%20models%20walking%2C%20elegant%20avant-garde%20designs%2C%20dramatic%20stage%20lighting%2C%20luxury%20fashion%20event%2C%20sophisticated%20atmosphere%2C%20editorial%20photography&width=800&height=450&seq=article-thumb-07&orientation=landscape",
    category: "fashion",
    categoryName: "时尚",
    views: 198000,
    likes: 44500,
    duration: "14:30",
    author: "时尚编辑Mia",
    authorAvatar: "https://readdy.ai/api/search-image?query=Chinese%20fashion%20editor%20woman%20portrait%2C%20elegant%20style%2C%20chic%20outfit%2C%20confident%20expression%2C%20modern%20office%20background%2C%20professional%20lighting&width=80&height=80&seq=avatar-07&orientation=squarish",
    date: "2026-07-28",
    tags: ["时装周", "穿搭", "流行趋势", "秋冬", "时尚"],
    featured: false,
    content: `<h2>2026秋冬时装周五大趋势</h2>
<p>随着米兰、巴黎、纽约、伦敦四大时装周的落幕，2026秋冬的流行趋势已经明朗。让我们一起来看看这个秋冬该怎么穿。</p>
<h3>趋势一： oversized 廓形回归</h3>
<p>超大号的西装外套、宽松的阔腿裤纷纷出现在T台上。舒适与时尚从来不是对立面。</p>
<h3>趋势二：皮革元素升级</h3>
<p>今年的皮革不再局限于黑色，酒红、墨绿、驼色等温暖色调成为主流，材质也更加柔软轻盈。</p>
<h3>趋势三：层次叠穿</h3>
<p>衬衫+针织背心+外套的三层叠穿法成为秋冬标配，既保暖又有型。</p>
<h3>趋势四：金属光泽</h3>
<p>银色、金色的金属光泽面料在晚装中大量出现，派对季的穿搭利器。</p>
<h3>趋势五：复古印花</h3>
<p>70年代的复古印花强势回归，无论是连衣裙还是衬衫，印花元素都能让你的造型更加出彩。</p>
<p>掌握这五大趋势，你就是这个秋冬最会穿的人！</p>`,
  },
  {
    id: "comedy-show-highlights",
    title: "爆笑合集 | 2026年最搞笑的综艺名场面，笑到肚子疼！",
    description: "精选2026年各大综艺节目中最搞笑的片段合集，包括脱口秀、真人秀、喜剧大赛等，保证让你笑出腹肌！",
    thumbnail: "https://readdy.ai/api/search-image?query=Colorful%20comedy%20show%20stage%20with%20bright%20spotlights%2C%20comedian%20performing%2C%20joyful%20audience%2C%20vibrant%20atmosphere%2C%20entertainment%20show%20photography%2C%20warm%20stage%20lighting&width=800&height=450&seq=article-thumb-08&orientation=landscape",
    category: "entertainment",
    categoryName: "娱乐",
    views: 680000,
    likes: 168000,
    duration: "16:50",
    author: "综艺达人小美",
    authorAvatar: "https://readdy.ai/api/search-image?query=Young%20Chinese%20woman%20portrait%2C%20bright%20smile%2C%20casual%20colorful%20outfit%2C%20lively%20expression%2C%20clean%20studio%20lighting%2C%20fresh%20natural%20look&width=80&height=80&seq=avatar-08&orientation=squarish",
    date: "2026-08-06",
    tags: ["综艺", "搞笑", "脱口秀", "喜剧", "名场面"],
    featured: true,
    content: `<h2>笑到停不下来！年度综艺名场面</h2>
<p>2026年的综艺节目精彩纷呈，诞生了无数让人捧腹大笑的经典场面。我们精选了其中最搞笑的片段，让你一次笑个够。</p>
<h3>脱口秀大赛爆梗合集</h3>
<p>今年的脱口秀大赛选手们金句频出，从职场吐槽到生活百态，每一个段子都精准戳中笑点。</p>
<h3>真人秀意外名场面</h3>
<p>真人秀的魅力就在于不可预测。嘉宾们的各种意外反应和即兴发挥，比剧本写出来的还要精彩。</p>
<h3>喜剧大赛神级表演</h3>
<p>新一届喜剧大赛涌现出众多实力派选手，他们的作品既有深度又不失趣味，让人笑中带泪。</p>
<h3>综艺新人惊艳亮相</h3>
<p>今年综艺圈注入了一批新鲜血液，他们带来了全新的表演风格和创作思路。</p>
<p>温馨提示：观看时请勿进食饮水，以免笑喷！</p>`,
  },
  {
    id: "smart-home-2026",
    title: "2026智能家居全攻略 | 花最少的钱打造最聪明的家",
    description: "从智能音箱到全屋自动化，我们实测了市场上最热门的智能家居产品，为你推荐最具性价比的选择。",
    thumbnail: "https://readdy.ai/api/search-image?query=Modern%20smart%20home%20living%20room%20with%20automated%20lighting%2C%20voice%20assistant%20device%2C%20clean%20minimalist%20interior%20design%2C%20natural%20light%2C%20warm%20cozy%20atmosphere%2C%20technology%20lifestyle%20photography&width=800&height=450&seq=article-thumb-09&orientation=landscape",
    category: "tech",
    categoryName: "科技",
    views: 178000,
    likes: 36700,
    duration: "19:12",
    author: "科技极客阿杰",
    authorAvatar: "https://readdy.ai/api/search-image?query=Young%20Chinese%20tech%20enthusiast%20portrait%2C%20modern%20glasses%2C%20friendly%20expression%2C%20casual%20hoodie%2C%20studio%20lighting%2C%20clean%20professional%20look&width=80&height=80&seq=avatar-02&orientation=squarish",
    date: "2026-07-25",
    tags: ["智能家居", "科技", "自动化", "性价比", "评测"],
    featured: false,
    content: `<h2>用科技让家更聪明</h2>
<p>智能家居不再是科幻电影里的场景，而是实实在在可以提升生活品质的选择。而且，打造智能家居的成本比你想的要低得多。</p>
<h3>入门级智能家居方案（预算3000元以内）</h3>
<p>智能音箱 + 智能灯泡 + 智能插座的基础组合，就能实现语音控制和远程操控。适合智能家居新手。</p>
<h3>进阶级方案（预算5000-10000元）</h3>
<p>加入智能门锁、智能摄像头、智能窗帘等设备，实现安防和便利性的双重提升。</p>
<h3>全屋智能方案（预算20000元以上）</h3>
<p>覆盖灯光、温控、安防、影音、窗帘的全方位智能系统，通过场景联动实现真正的全屋自动化。</p>
<h3>避坑指南</h3>
<p>选择同一生态系统的产品，避免不同品牌之间无法联动的尴尬。优先选择支持Matter协议的产品。</p>
<p>花合适的钱，享受科技带来的便利，这才是智能家居的正确打开方式！</p>`,
  },
  {
    id: "street-dance-tutorial",
    title: "街舞入门教学 | 零基础30分钟学会一支完整舞蹈",
    description: "专业街舞老师分步教学，从热身到成品舞，每个动作都仔细拆解，让你在家也能学会帅气的街舞。",
    thumbnail: "https://readdy.ai/api/search-image?query=Energetic%20street%20dance%20studio%20with%20mirror%20wall%2C%20dancer%20in%20motion%2C%20urban%20style%2C%20dynamic%20pose%2C%20colorful%20graffiti%20background%2C%20vibrant%20youth%20culture%20photography&width=800&height=450&seq=article-thumb-10&orientation=landscape",
    category: "entertainment",
    categoryName: "娱乐",
    views: 223000,
    likes: 56700,
    duration: "28:40",
    author: "舞者小杰",
    authorAvatar: "https://readdy.ai/api/search-image?query=Young%20Chinese%20street%20dancer%20portrait%2C%20cool%20urban%20style%2C%20confident%20look%2C%20cap%20and%20hoodie%2C%20dance%20studio%20background%2C%20dynamic%20lighting&width=80&height=80&seq=avatar-09&orientation=squarish",
    date: "2026-07-22",
    tags: ["街舞", "舞蹈教学", "入门", "HIPHOP", "才艺"],
    featured: false,
    content: `<h2>零基础也能学会跳街舞</h2>
<p>街舞不是只有专业舞者才能跳的。只要掌握了正确的方法，任何人都能在短时间内学会一支完整的舞蹈。</p>
<h3>热身环节（5分钟）</h3>
<p>充分的热身是避免受伤的关键。从头到脚逐步活动每个关节，让身体进入运动状态。</p>
<h3>基础动作学习（10分钟）</h3>
<p>学习这支舞蹈所需的几个核心动作：Wave、Pop、Lock等。每个动作都会详细拆解，确保你能跟上。</p>
<h3>组合练习（10分钟）</h3>
<p>将学到的动作按照音乐节奏串联起来，形成完整的舞蹈组合。</p>
<h3>完整演绎（5分钟）</h3>
<p>跟着音乐完整跳一遍，感受舞蹈带来的快乐和成就感！</p>
<p>跳舞不仅是一种才艺，更是一种释放压力、表达自我的方式。跳起来吧！</p>`,
  },
  {
    id: "photography-tips-phone",
    title: "手机摄影进阶技巧 | 不用单反也能拍出大片感的10个秘诀",
    description: "摄影师教你用手机拍出专业级照片，从构图到后期，10个实用技巧让你的朋友圈照片质感翻倍。",
    thumbnail: "https://readdy.ai/api/search-image?query=Smartphone%20photography%20setup%20with%20phone%20on%20tripod%2C%20scenic%20nature%20background%20with%20golden%20hour%20light%2C%20creative%20composition%2C%20warm%20sunset%20tones%2C%20professional%20mobile%20photography&width=800&height=450&seq=article-thumb-11&orientation=landscape",
    category: "lifestyle",
    categoryName: "生活",
    views: 156000,
    likes: 34200,
    duration: "11:55",
    author: "摄影师阿楠",
    authorAvatar: "https://readdy.ai/api/search-image?query=Chinese%20photographer%20man%20portrait%2C%20camera%20in%20hand%2C%20artistic%20look%2C%20casual%20outdoor%20style%2C%20natural%20lighting%2C%20creative%20vibe&width=80&height=80&seq=avatar-10&orientation=squarish",
    date: "2026-07-20",
    tags: ["手机摄影", "拍照技巧", "构图", "后期", "朋友圈"],
    featured: false,
    content: `<h2>手机也能拍出大片</h2>
<p>现在的手机摄像头越来越强大，已经能够满足大部分日常拍摄需求。关键不在于设备，而在于你怎么用它。</p>
<h3>技巧一：善用网格线</h3>
<p>打开相机设置中的网格线功能，利用三分法构图，把主体放在交叉点上，照片瞬间变得有章法。</p>
<h3>技巧二：寻找自然光</h3>
<p>光线是摄影的灵魂。尽量在自然光充足的时段拍摄，黄金时段（日出后和日落前1小时）的光线最柔和美丽。</p>
<h3>技巧三：低角度拍摄</h3>
<p>不要总是站着拍。蹲下来、趴下去，低角度能带来全新的视觉感受。</p>
<h3>技巧四：注意背景</h3>
<p>简洁的背景能让主体更加突出。拍摄前先扫一眼背景，避开杂乱的元素。</p>
<h3>技巧五：后期调色</h3>
<p>适当的后期处理能让照片锦上添花。调整曝光、对比度、饱和度等基本参数即可。</p>
<p>掌握这些技巧，你的手机作品一定会让人眼前一亮！</p>`,
  },
  {
    id: "baking-beginners-guide",
    title: "烘焙新手必看 | 5款零失败甜点配方，烤箱从此不闲置",
    description: "精选5款适合新手的烘焙配方，从曲奇饼干到戚风蛋糕，每一步都有详细讲解，保证一次成功！",
    thumbnail: "https://readdy.ai/api/search-image?query=Beautiful%20assortment%20of%20homemade%20baked%20goods%20on%20wooden%20table%2C%20cookies%20and%20cakes%2C%20warm%20kitchen%20lighting%2C%20rustic%20style%2C%20golden%20brown%20pastries%2C%20cozy%20baking%20photography&width=800&height=450&seq=article-thumb-12&orientation=landscape",
    category: "food",
    categoryName: "美食",
    views: 132000,
    likes: 28900,
    duration: "25:30",
    author: "烘焙达人甜甜",
    authorAvatar: "https://readdy.ai/api/search-image?query=Chinese%20woman%20baker%20portrait%2C%20warm%20smile%2C%20apron%2C%20holding%20baked%20goods%2C%20kitchen%20background%2C%20soft%20natural%20lighting&width=80&height=80&seq=avatar-11&orientation=squarish",
    date: "2026-07-18",
    tags: ["烘焙", "甜品", "新手", "配方", "蛋糕"],
    featured: false,
    content: `<h2>烘焙其实很简单</h2>
<p>很多人买了一台烤箱却不知道从何下手。其实烘焙没有想象中那么难，选对配方，按步骤来，成功率非常高。</p>
<h3>配方一：黄油曲奇</h3>
<p>最基础的烘焙入门。只需黄油、糖粉、鸡蛋、低筋面粉四种原料，挤花、烘烤15分钟，酥脆可口的曲奇就完成了。</p>
<h3>配方二：纸杯蛋糕</h3>
<p>小巧可爱的纸杯蛋糕是聚会必备。掌握面糊的搅拌技巧是关键，切记不要过度搅拌。</p>
<h3>配方三：蔓越莓司康</h3>
<p>英式下午茶的经典搭配。外酥内软，搭配果酱和奶油，幸福感爆棚。</p>
<h3>配方四：原味戚风蛋糕</h3>
<p>戚风蛋糕的难点在于蛋白打发。只要蛋白打发到硬性发泡状态，基本就不会失败。</p>
<h3>配方五：巧克力布朗尼</h3>
<p>浓郁湿润的巧克力布朗尼，简单到几乎不可能失败。所有原料混合均匀，送入烤箱即可。</p>
<p>从这五款开始你的烘焙之旅，烤箱再也不会闲置了！</p>`,
  },
];

export const getArticlesByCategory = (slug: string): Article[] => {
  return articles.filter((a) => a.category === slug);
};

export const getFeaturedArticles = (): Article[] => {
  return articles.filter((a) => a.featured);
};

export const getArticleById = (id: string): Article | undefined => {
  return articles.find((a) => a.id === id);
};

export const getRelatedArticles = (article: Article, count: number = 3): Article[] => {
  return articles
    .filter((a) => a.id !== article.id && a.category === article.category)
    .slice(0, count);
};